import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import * as methods from "../reducers/methods";
import { StoreState } from "../reducers";
import type { Action } from "../actions/types";
import { sessionId } from "../config";

const GIT_SHA = process.env.REACT_APP_CIRCLE_SHA1;
const BUILD_DATETIME = process.env.REACT_APP_BUILD_DATETIME;

const appMiddleware: Middleware =
  <S>({ getState }: MiddlewareAPI<S>) =>
  (next: Dispatch<S>) =>
  (action: any): any => {
    // display the action per usual (ie. in case we want
    // to capture all REMOTE_REQUEST)
    next(action);

    // little typing hack State => any => StoreState
    // since we know the state is a StoreState in our app
    // tslint:disable-next-line:no-any
    const state: StoreState = getState() as any;

    // this is the widgetId known by the merchantSDK. Since
    // we can have the same widget displayed more than once
    // the merchant SDK uses the widgetConfigId to target
    // the widget
    const widgetId = methods.getWidgetConfigId(state);

    if ((action as Action).type === "SEND_MESSAGE_TO_MERCHANT") {
      window.parent.postMessage(
        {
          ...action.payload,
          widgetId,
          version: GIT_SHA,
          builtOn: BUILD_DATETIME,
        },
        "*"
      );
    }

    if ((action as Action).type === "MERCHANT_REMOTE_REQUEST") {
      window.parent.postMessage(
        {
          ...action,
          data: {
            ...action.data,
            sessionId,
          },
          widgetId,
          type: "CORS_REQUEST",
          version: GIT_SHA,
          builtOn: BUILD_DATETIME,
        },
        "*"
      );
    }
  };

export default appMiddleware;
